import { observable, makeObservable, action } from 'mobx';
import { getCommentConfigReq } from '@/api/comment';

class Comment {
    constructor() {
        makeObservable(this);
    }

    @observable
    commentConfig = {};

    @action
    setCommentConfig = (data) => {
        this.commentConfig = data;
    };

    @action
    getMenuAuth = async (json) => {
        let res = await getCommentConfigReq(json);
        if (res.success) {
            this.setCommentConfig(res.data);
            return res.data;
            // this.setCommentConfig({ comment_status: 0, display_status: 1 });
            // return { comment_status: 0, display_status: 1 };
        }
    };
}

export default new Comment();
